<script lang="ts">
	import { page } from '$app/stores';
	import ArticleCard from '$lib/components/Blog/ArticleCard.svelte';
	import ArticleList from '$lib/components/Blog/ArticleList.svelte';
	import ArticleView from '$lib/components/Blog/ArticleView.svelte';
	import AsideBanner from '$lib/components/Blog/Banners/AsideBanner.svelte';
	import NewsletterForm from '$lib/components/Global/Newsletter/NewsletterForm.svelte';
	import __ from '$lib/stores/TranslationStore';
	import { toWebp } from '$lib/utils/helpers/convert';
	import type { PageData } from './$types';

	export let data: PageData;

	let article: Article, relatedArticles: IndexArticle[], mostViewedFromCategory: IndexArticle[];
	$: article = data.article;
	$: relatedArticles = data.related;
	$: mostViewedFromCategory = data.mostViewedFromCategory;

	$: categorySlug = article?.category?.main?.slug;
	// $: plainTextIntroduction = article.introduction
	// 	? article.introduction.replace(/<[^>]+>/g, '').replace(/(?<=[.,])(?=[^\s.,])/g, ' ')
	// 	: '';

	$: filename = toWebp(`https://media-manager.poupancanominuto.com/900/${article.cover_name}`);
</script>

<svelte:head>
	<link rel="dns-prefetch" href="https://www.instagram.com" />

	<title>{article.meta_title ? article.meta_title : article.title} </title>
	<meta name="description" content={article.meta_description ? article.meta_description : article.introduction_text} />
	<meta property="og:url" content={$page.url.href} />
	<meta property="og:site_name" content="Poupança no Minuto" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content={article.meta_title ? article.meta_title : article.title} />
	<meta property="og:description" content={article.meta_description ? article.meta_description : article.introduction_text} />
	<meta property="og:image" content={filename} />
	<meta property="og:image:url" content={filename} />
	<meta property="og:image:secure_url" content={filename} />
	<meta property="og:image:width" content="1280" />
	<meta property="og:image:width" content="720" />
</svelte:head>

<div
	class="container mx-auto space-y-8 bg-white px-5 py-12 sm:container sm:mx-auto"
	data-sveltekit-reload
>
	<div class="flex flex-col gap-y-6 lg:flex-row lg:gap-x-14 xl:gap-x-24">
		<main class="basis-3/4">
			<ArticleView {article} class="space-y-6" />
		</main>
		<aside class="flex shrink-0 basis-1/4 flex-col justify-start gap-y-6">
			<AsideBanner
				class="hidden lg:block"
				category={['credito-habitacao', 'seguros'].includes(categorySlug)
					? categorySlug
					: 'simuladores'}
			/>
			<ArticleList
				title={$__('Leia também')}
				articles={mostViewedFromCategory}
				let:article={relArticle}
				contentClass="grid-cols-none divide-y-2"
			>
				<header slot="header" class="flex py-4" let:title>
					<h3 class="text-neutral-500">{title}</h3>
				</header>
				<ArticleCard
					slot="first"
					class="pb-6"
					let:article={firstRelArticle}
					article={firstRelArticle}
					titleClass="line-clamp-3 text-2xl"
					labelClass="text-sm font-semibold uppercase text-primary"
					compact
					withoutCover
				/>
				<ArticleCard
					class="py-6"
					article={relArticle}
					titleClass="line-clamp-3 text-2xl"
					labelClass="text-sm font-semibold uppercase text-primary"
					compact
					withoutCover
				/>
				<ArticleCard
					slot="last"
					class="pt-6"
					let:article={lastRelArticle}
					article={lastRelArticle}
					titleClass="line-clamp-3 text-2xl"
					labelClass="text-sm font-semibold uppercase text-primary"
					compact
					withoutCover
				/>
			</ArticleList>
			<div class="sticky top-28 hidden lg:block">
				<NewsletterForm class="hidden lg:flex lg:px-3 xl:px-7" intent="small" />
			</div>
		</aside>
	</div>
	<aside>
		<ArticleList
			title={$__('Artigos relacionados')}
			articles={relatedArticles}
			contentClass="md:grid-cols-2 lg:grid-cols-3 gap-8 xl:gap-x-14"
			seeMoreUrl="{$page.data?.location?.origin}/artigos/sobre/artigo/{article.slug}/relacionados"
		/>
	</aside>
</div>
<NewsletterForm class="min-h-[480px] lg:hidden" intent="small" />
<AsideBanner
	small
	class="mx-auto py-5 lg:hidden"
	category={['credito-habitacao', 'seguros'].includes(categorySlug) ? categorySlug : 'simuladores'}
/>
